export function steps() {

	if ($(".Container__progress-bar__js").length > 0) {

		const infoItem = $(".Steps_info-items__js");
		const infoTitle = $(".Steps_info-title__js");
		const infoText = $(".Steps_info-text__js");
		let state = 0;
		let maxState = $(".cont span").length - 1;

		// Функция в которой прописанна выводимая информация на определенных шагах
		function makeUI() {
			if (state === 0) {
				infoItem.animate({ opacity: 0 }, 100);
				$('#progress-bar').attr("value", "0")
				setTimeout(() => {
					// Задается тект который будет проставляться на определенной "стадии"
					infoTitle.text("Оценка сайта и составление КП");
					infoText.text("SEO-специалист проведет краткий аудит и составит семантическое ядро в соответствии с тематикой сайта. На основании этого будет подготовлено индивидуальное коммерческое предложение.");
					infoItem.animate({ opacity: 1 }, 100);
				}, 100);
			}

			else if (state === 1) {
				infoItem.animate({ opacity: 0 }, 100);
				$('#progress-bar').attr("value", "20")
				setTimeout(() => {
					infoTitle.text("Подписание договора и оплата, передача доступов к сайту");
					infoText.text("Для более оперативной взаимной коммуникации назначается персональный менеджер, который будет сопровождать дальнейшую работу по проекту. Получая доступы, мы запускаем проект в работу.");
					infoItem.animate({ opacity: 1 }, 100);
				}, 100);
			}

			else if (state === 2) {
				$('#progress-bar').attr("value", "40")
				infoItem.animate({ opacity: 0 }, 100);
				setTimeout(() => {
					infoTitle.text("Полный аудит сайта и конкурентов");
					infoText.text("SEO-специалист проводит подробный анализ сайта и сравнение с конкурентами, чтобы выявить и исправить уязвимые места ресурса. На сайт вносятся изменения для улучшения его позиций и увеличения посещаемости. ");
					infoItem.animate({ opacity: 1 }, 100);
				}, 100);;
			}

			else if (state === 3) {
				$('#progress-bar').attr("value", "60")
				infoItem.animate({ opacity: 0 }, 100);
				setTimeout(() => {
					infoTitle.text("Составление тех. задания и индивидуальной стратегии. Вывод сайта в топ");
					infoText.text("Разрабатываем конкретную тактику продвижения, ориентируясь на актуальные требования поисковика. Составляем ТЗ и передаем задачи в работу техническому отделу.");
					infoItem.animate({ opacity: 1 }, 100);
				}, 100);
			}

			else if (state === 4) {
				$('#progress-bar').attr("value", "80")
				infoItem.animate({ opacity: 0 }, 100);
				setTimeout(() => {
					infoTitle.text("Удержание сайта в ТОПе поисковой выдачи после достижения данного результата");
					infoText.text("Регулярно проводим аудиты и отслеживаем позиции сайта. При необходимости корректируем SEO-стратегии с осуществлением работ техническим отделом.");
					infoItem.animate({ opacity: 1 }, 100);
				}, 100);
			}

			else if (state === 5) {
				$('#progress-bar').attr("value", "100")
				infoItem.animate({ opacity: 0 }, 100);
				setTimeout(() => {

					infoTitle.text("Вы видите реальный рост позиций и увеличение количества заявок");
					infoText.text("Вывод сайта в ТОП поисковой выдачи создает условия для увеличения посещаемости, что, в свою очередь, приводит к увеличению конверсии сайта и узнаваемости бренда.");
					infoItem.animate({ opacity: 1 }, 100);
				}, 100);
			}

			$(".state-active").removeClass("state-active");
			$(`.bar-item:eq(${state})`).addClass("state-active");
		}

		// изменение переменной состояния при клике на шаги "прогресс бара"
		$(".cont span").click(function () {
			$(this).prevAll().addClass("blue");
			$(this).nextAll().removeClass("blue");
			$(this).removeClass("blue");
			state = $(this).data("id");
			makeUI();
		});


		// анимация для мобильной версии
		function mobileStepAnim () {
			const progressBarContainer = $('.cont__js');

			if ($(window).width() <= '767') {
				let barItem = document.querySelectorAll('.bar-item__js');

				for (var i = 0; i < barItem.length; i++) {

					let currentBarPos

					// устанавливаем для прогрессбара позицию в зависимости от того на какой элемент нажали
					switch (i) {
						case 0: currentBarPos = "0%"; break;
						case 1: currentBarPos = "-5%"; break;
						case 2: currentBarPos = "-40%"; break;
						case 3: currentBarPos = "-60%"; break;
						case 4: currentBarPos = "-95%"; break;
						case 5: currentBarPos = "-105%"; break;
					}

					barItem[i].addEventListener('click', () => {
						progressBarContainer.css('left', currentBarPos);
					})
				}
			};
		}
		
		mobileStepAnim();
		
		$(window).resize(mobileStepAnim)
	};
};